module.exports = __webpack_public_path__ + "img/przelewy24Logo.31d44ca1.svg";